import {Box, Button, Dialog, DialogTitle, TextField} from '@mui/material'
import {ITenant} from 'app/models/tenant'
import {PropertyEditor} from './usePropertyEditor'

export function DialogEditTenant(props: {editor: PropertyEditor<ITenant>}) {
  const editor = props.editor
  if (!editor.obj) {
    return <></>
  }
  return (
    <Dialog open={true}>
      <DialogTitle sx={{backgroundColor: 'black', color: 'white'}}>
        {editor.createMode ? `Create Tenant` : `Editing Tenant "${editor.obj.name}"`}
      </DialogTitle>
      <Box sx={{margin: '20px', minWidth: '500px', fontSize: '16px'}}>
        <Box sx={{marginBottom: '12px'}}>
          <form noValidate autoComplete='off'>
            <TextField
              id='name'
              label='Tenant name'
              value={editor.getString('name') ?? ''}
              onChange={(event: any) => {
                editor.setString('name', event.target.value)
              }}
            />
          </form>
        </Box>
        <Box sx={{display: 'flex'}}>
          <Box sx={{flex: '1 1 auto'}}></Box>
          <Box sx={{flex: '0 0 auto', display: 'flex'}}>
            <Button sx={{fontSize: '14px'}} onClick={editor.cancel}>
              Cancel
            </Button>
            <Button sx={{fontSize: '14px'}} onClick={editor.confirm}>
              OK
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  )
}
